import { Tag } from "@blueprintjs/core"
import { ITagItem } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */
export interface ITagCardFieldProps {
   item: ITagItem
}
const TagCardField = ({item, ...props}: ITagCardFieldProps): JSX.Element => {
    return <Tag 
        round={!!item.round} 
        className={`px-3 py-2 pe-tag-card-field ${item.checked ? "bg-danger" : ""}`}
    >
        <div className="d-flex ">
            {item.title}
        </div>
    </Tag>
}
export default TagCardField